var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLeftRightArrow(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 152,
    height: 45,
    viewBox: "0 0 152 45",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_336_30546)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_336_30546)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M31.2498 21.9415L36.2 16.9913C36.6555 16.5358 36.6555 15.7972 36.2 15.3417C35.7444 14.8861 35.0058 14.8861 34.5503 15.3417L28.7754 21.1165C28.3198 21.5721 28.3198 22.3108 28.7754 22.7664L34.5503 28.5413C35.0058 28.9969 35.7444 28.9969 36.2 28.5413C36.6555 28.0858 36.6555 27.3472 36.2 26.8917L31.2498 21.9415Z",
    fill: "#5F5F5F"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M46.1666 22C46.1666 21.3557 45.6443 20.8333 45 20.8333H30.4166C29.7723 20.8333 29.25 21.3557 29.25 22C29.25 22.6443 29.7723 23.1667 30.4166 23.1667H45C45.6443 23.1667 46.1666 22.6443 46.1666 22Z",
    fill: "#5F5F5F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1 44V0H-1V44H1Z",
    fill: "#434343",
    mask: "url(#path-3-inside-1_336_30546)"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "path-6-inside-2_336_30546",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M76 0H152V44H76V0Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M76 0H152V44H76V0Z",
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M119.583 21.9415L114.633 16.9913C114.178 16.5358 114.178 15.7972 114.633 15.3417C115.089 14.8861 115.827 14.8861 116.283 15.3417L122.058 21.1165C122.513 21.5721 122.513 22.3108 122.058 22.7664L116.283 28.5413C115.827 28.9969 115.089 28.9969 114.633 28.5413C114.178 28.0858 114.178 27.3472 114.633 26.8917L119.583 21.9415Z",
    fill: "#B9B9B9"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M104.667 22C104.667 21.3557 105.189 20.8333 105.833 20.8333H120.417C121.061 20.8333 121.583 21.3557 121.583 22C121.583 22.6443 121.061 23.1667 120.417 23.1667H105.833C105.189 23.1667 104.667 22.6443 104.667 22Z",
    fill: "#B9B9B9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77 44V0H75V44H77Z",
    fill: "#434343",
    mask: "url(#path-6-inside-2_336_30546)"
  })), /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 151,
    height: 43,
    rx: 7.5,
    stroke: "#434343"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_336_30546",
    x: 0,
    y: 0,
    width: 152,
    height: 44.5,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 0.5
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.321569 0 0 0 0 0.321569 0 0 0 0 0.321569 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_336_30546"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_336_30546",
    result: "shape"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_336_30546"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 152,
    height: 44,
    rx: 8,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLeftRightArrow);
export default __webpack_public_path__ + "static/media/LeftRightArrow.7e358fac9d82f1275400c8ebac374e2d.svg";
export { ForwardRef as ReactComponent };